import { Component, Input, OnInit, TemplateRef, Output, EventEmitter } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
import { NbDialogService, NbDialogRef } from '@nebular/theme';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';

import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  templateUrl: './AccionTablaArchivosEntidad.component.html'
})
export class AccionTablaArchivosEntidadComponent implements ViewCell, OnInit {

  renderValue: string;
  activeModal: any;
  resultadoRequest: any;
  archivosDocumento: any[];
  tipo:any;

  @Input() value: string | number;
  @Input() rowData: any;


  constructor(private dialogService: NbDialogService, private modalService: NgbModal, private _http: PeticionesHttpBackEndService) {
  }

  ngOnInit() {
 
   
  }

  verArchivo(){
    this._http.getOneReg("v1/viewFile",this.rowData.archivoId).subscribe(
      result => {
       this.resultadoRequest = result;
       const win = window.open("","_blank");
        let html = '';
        let cadena = "";
        let tamaño ="";
        this.archivosDocumento = [{
          'pdf':"application/pdf", 
          'doc':"application/msword",
          'docx':"application/vnd.openxmlformats-officedocument.wordprocessingml.document", 
           'csv':"text/csv",
           'xsl':"application/vnd.ms-excel",
           '7z':"application/x-7z-compressed",
           'zip':"application/zip",
           'tar':"application/x-tar",
           'jpg':"image/jpeg",
           'jpeg':"image/jpeg",
           'png':"image/png"
        }];
        for (let i = 0; i < this.archivosDocumento.length; i++) {
          let entry = this.archivosDocumento[i];
         this.tipo = entry[(this.rowData.nombreArchivo).split('.')[1]];
          }
          cadena =  this.tipo;
       const linkSource = 'data:'+cadena+';base64,' + this.resultadoRequest.Archivo;
        const downloadLink = document.createElement("a");
        const fileName = this.rowData.nombreArchivo;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        /*  tamaño = "width=100% height=100%";
        html += '<html>';
        html += '<body style="margin:0!important">';
          html += '<a href="data:'+cadena+';base64,'+this.resultadoRequest.Archivo+'" type="'+cadena+'" >Descargar</a>.</p>';
          html += '<iframe '+tamaño+' src="data:'+cadena+';base64,'+this.resultadoRequest.Archivo+'" type="'+cadena+'" frameborder="0" allowfullscreen><iframe/>';
        //html += '<img src="data:'+cadena+';base64,'+this.resultadoRequest.Archivo+'" type="'+cadena+'" >'
        //html += '<iframe style="border: none" '+tamaño+' src="https://view.officeapps.live.com/op/embed.aspx?src="data:'+cadena+';base64,'+this.resultadoRequest.Archivo+'&embedded=true" type="'+cadena+'"></iframe>';
      
        html += '</body>';
        html += '</html>';*/

        setTimeout(() => {
          win.document.write(html);
        }, 0);
      }
    );
    
  }


}
